import React from "react";
import { adminInputClass } from "./adminTextInput";

// rótulo + campo + dica/contador, no padrão visual dos formulários do painel
export default function AdminField({
    label,
    htmlFor,
    required = false,
    hint,
    counter,
    className = "",
    children
}: {
    label: React.ReactNode;
    htmlFor?: string;
    required?: boolean;
    hint?: React.ReactNode;
    counter?: { current: number, max: number };
    className?: string;
    children: React.ReactNode;
}) {
    return (
        <div className={`flex flex-col gap-1.5 ${className}`}>
            <label htmlFor={htmlFor} className="text-sm font-semibold text-gray-700">
                {label}
                {
                    required ?
                        <span className="text-red-600 ml-0.5">*</span>
                        : null
                }
            </label>
            {children}
            {
                hint || counter ?
                    <div className="flex items-start justify-between gap-4 text-xs text-gray-500">
                        <span>{hint}</span>
                        {
                            counter ?
                                <span className="tabular-nums whitespace-nowrap">{counter.current}/{counter.max}</span>
                                : null
                        }
                    </div>
                    : null
            }
        </div>
    )
}

export function AdminSelect({ value, onChange, children, disabled = false, id, className = "" }: { value: string, onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void, children: React.ReactNode, disabled?: boolean, id?: string, className?: string }) {
    return (
        <select id={id} value={value} onChange={onChange} disabled={disabled} className={`${adminInputClass} h-10 pr-8 cursor-pointer ${className}`}>
            {children}
        </select>
    )
}

export function AdminTextarea({ value, onChange, disabled = false, id, placeholder, rows = 4, className = "" }: { value: string, onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void, disabled?: boolean, id?: string, placeholder?: string, rows?: number, className?: string }) {
    return (
        <textarea id={id} value={value} onChange={onChange} disabled={disabled} placeholder={placeholder} rows={rows} className={`${adminInputClass} resize-y min-h-[6rem] ${className}`} />
    )
}
